// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    'aws_project_region': 'eu-west-2',
    'aws_cognito_identity_pool_id': 'eu-west-2:a1df6fcc-2e7c-459b-878f-ea56cb46358f',
    'aws_cognito_region': 'eu-west-2',
    'aws_user_pools_id': 'eu-west-2_llCtWwW8u',
    'aws_user_pools_web_client_id': '5fqstcrnpqv2ti24f3tt3nc7gt',
    'oauth': {
        'domain': 'betterspace-prod-dev-demo.auth.eu-west-2.amazoncognito.com',
        'scope': [
            'phone',
            'email',
            'openid',
        ],
        'redirectSignIn': 'https://demo-user.betterspace.uk/callback',
        'redirectSignOut': 'https://demo-user.betterspace.uk/logout',
        'responseType': 'token'
    },
    'federationTarget': 'COGNITO_USER_POOLS',
    'aws_cloud_logic_custom': [
        {
            'name': 'AdminQueries',
            'endpoint': 'https://cdqx87bvb7.execute-api.eu-west-2.amazonaws.com/demo',
            'region': 'eu-west-2'
        }
    ],
    'aws_content_delivery_bucket': 'webapp-production-betterspace-demo',
    'aws_content_delivery_bucket_region': 'eu-west-2',
    'aws_content_delivery_url': 'https://d1jcr0g4rf5t8i.cloudfront.net'
};


export default awsmobile;